export enum FieldTypes {
	checkbox = 'checkbox',
	text = 'text',
	upload = 'upload',
	date = 'date',
	number = 'number',
	radio = 'radio',
	select = 'select',
}
